import axios from 'axios';

import { API_BASE_URL } from '../api';
import { auth } from '../firebase/firebase';

export type NotificationChannel = 'telegram' | 'slack' | 'email';

export interface LinkedAccount {
  channel: NotificationChannel;
  externalId: string;
  workspaceId?: string;
  linkedAt: string;
}

export const fetchLinkedAccounts = async (): Promise<LinkedAccount[]> => {
  const token = await auth.currentUser?.getIdToken();
  const response = await axios.get(`${API_BASE_URL}/api/notifications/linked`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

export const getTelegramLink = async (): Promise<{ url: string }> => {
  const token = await auth.currentUser?.getIdToken();
  const response = await axios.get(`${API_BASE_URL}/api/notifications/telegram/link`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

export const registerEmail = async (email: string): Promise<{ sent: boolean }> => {
  const token = await auth.currentUser?.getIdToken();
  const response = await axios.post(
    `${API_BASE_URL}/api/notifications/email/register`,
    { email },
    { headers: { Authorization: `Bearer ${token}` } },
  );
  return response.data;
};

export const disconnectNotificationChannel = async (channel: NotificationChannel): Promise<{ ok: boolean }> => {
  const token = await auth.currentUser?.getIdToken();
  const response = await axios.delete(`${API_BASE_URL}/api/notifications/integrations/${channel}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};
